/**
 * This file contains scripts used in microsites
 */

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import initFilters from './microsite-filters'
import {initSlideshows} from './microsite-sliders'
import {initHero} from './microsite-sliders'
import {initMarquee} from './microsite-sliders'


Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.start()

if (document.querySelector('.microsite-filter')) {
    initFilters()
}


if (document.querySelector('.microsite-slider-block')) {
    initSlideshows()
}


document.addEventListener("DOMContentLoaded", function () {

    if (document.querySelector('.microsite-hero-block')) {
        initHero()
    }
});


document.addEventListener("DOMContentLoaded", function () {

    if (document.querySelector('.microsite-marquee-block')) {
        initMarquee()
    }
});

console.log('microsite script!');


const mainNavigationWrapper = document.querySelector('.micro-site-header') as HTMLElement;
const articleHero = document.querySelector('.microsite-article__hero') as HTMLElement;
const main = document.getElementById('content');
const topNavigationLinks = document.querySelectorAll('.level-2');
const topNavigationButtons = document.querySelector('.button-list');
var detailsLevel2Elements = document.querySelectorAll('li.level-2 details');




document.addEventListener("DOMContentLoaded", function () {

    detailsLevel2Elements.forEach(function(detailsElement) {
        var detailsElementTyped = detailsElement as HTMLDetailsElement;

        detailsElementTyped.addEventListener('toggle', function() {
            if (main.contains(document.querySelector('.microsite-article__hero'))) {
                mainNavigationWrapper.classList.add('scrolled');
                topNavigationLinks.forEach(function(link) {
                    if (link instanceof HTMLElement) {
                        link.classList.add('scrolled');
                    }
                });
                topNavigationButtons.classList.add('scrolled');
            } else if (detailsElementTyped.open) {
                mainNavigationWrapper.classList.add('scrolled');
                topNavigationLinks.forEach(function(link) {
                    if (link instanceof HTMLElement) {
                        link.classList.add('scrolled');
                    }
                });
                topNavigationButtons.classList.add('scrolled');
            } else {
                mainNavigationWrapper.classList.remove('scrolled');
                topNavigationLinks.forEach(function(link) {
                    if (link instanceof HTMLElement) {
                        link.classList.remove('scrolled');
                    }
                });
                topNavigationButtons.classList.remove('scrolled');
            }
        });
    });
    
    const pageScroll = () => {
        const scrollPosition = window.scrollY;
        const threshold = 50;

        // mainNavigationWrapper.classList.toggle('scrolled', scrollPosition > threshold);

        if (scrollPosition > threshold) {
            mainNavigationWrapper.classList.add('scrolled')
            topNavigationLinks.forEach(function(link) {
                if (link instanceof HTMLElement) {
                    link.classList.add('scrolled');
                }
            });
            topNavigationButtons.classList.add('scrolled');
            
        }

        if (scrollPosition === 0 && !main.contains(document.querySelector('.microsite-article__hero')) ) {
            mainNavigationWrapper.classList.remove('scrolled')
            topNavigationLinks.forEach(function(link) {
                if (link instanceof HTMLElement) {
                    link.classList.remove('scrolled');
                }
            });
            topNavigationButtons.classList.remove('scrolled');
        } else {
            mainNavigationWrapper.classList.add('scrolled')
            topNavigationLinks.forEach(function(link) {
                if (link instanceof HTMLElement) {
                    link.classList.add('scrolled');
                }
            });
            topNavigationButtons.classList.add('scrolled');
        }

        if (menuToggle.classList.contains('active')) {
            mainNavigationWrapper.classList.add('scrolled')
        }
        
    };

    // Initial setup based on scroll position
    pageScroll();

    window.addEventListener('scroll', pageScroll);
});


// document.addEventListener('DOMContentLoaded', function () {
//     const detailsElements = Array.from(document.querySelectorAll('details'))
//         .filter(isHTMLDetailsElement);
//
//     function checkDetailsOpen() {
//         const isOpen = detailsElements.some((detail) => detail.open);
//         mainNavigationWrapper?.classList.toggle('scrolled', isOpen);
//     }
//
//     function isHTMLDetailsElement(element: Element): element is HTMLDetailsElement {
//         return element.tagName.toLowerCase() === 'details';
//     }
//
//     detailsElements.forEach((details) => {
//         details.addEventListener('toggle', checkDetailsOpen);
//         details.addEventListener('click', function () {
//             detailsElements.forEach((otherDetails) => {
//                 if (otherDetails !== details) {
//                     (otherDetails as HTMLElement).removeAttribute('open');
//                 }
//             });
//         });
//     });
//
//     document.addEventListener('click', function (event) {
//         const targetElement = event.target as HTMLElement;
//
//         if (!targetElement.closest('.details-container')) {
//             detailsElements.forEach((details) => details.removeAttribute('open'));
//         }
//     });
//
//     // Kolla direkt vid sidans laddning
//     checkDetailsOpen();
// });


const menuToggle = document.getElementById('menu-toggle') as HTMLElement;
const overlay = document.getElementById('overlay') as HTMLElement;


menuToggle.addEventListener('click', () => {
    menuToggle.classList.toggle('active');
    overlay.classList.toggle('open');
    // mainNavigationWrapper.classList.toggle('scrolled');
    mainNavigationWrapper?.classList.add('scrolled');

    if (menuToggle.classList.contains('active')) {
        mainNavigationWrapper?.classList.add('scrolled');
    }
});

menuToggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {

        menuToggle.classList.toggle('active');
        overlay.classList.toggle('open');
        // mainNavigationWrapper.classList.toggle('scrolled');

    }
});



// Click events menu

const openMegamenu = document.querySelectorAll('.open-megamenu');

openMegamenu.forEach((megamenu) => {
    megamenu.addEventListener('click', (event) => {
        event.stopPropagation();

        openLevel3.forEach((item3) => {
            document.querySelectorAll('.level-3').forEach((otherLevel3) => {
                if (otherLevel3 !== item3.closest('li').querySelector('.level-3')) {
                    otherLevel3.classList.remove('open');
                }
            });
        });
        
        megamenu.classList.toggle('rotate');
        mainNavigationWrapper.classList.add('scrolled')

        const parentLi = megamenu.closest('ul');
        const level3 = parentLi ? parentLi.querySelector('.level-3') : null;

        if (level3) {
            level3.classList.toggle('open');
        }
    });
});

document.addEventListener('click', (event) => {
    const clickedElement = event.target as HTMLElement;
    const isInsideLevel3 = clickedElement.closest('.level-3');

    if (!isInsideLevel3) {
        document.querySelectorAll('.level-3').forEach((level3) => {
            level3.classList.remove('open');
        });

        document.querySelectorAll('.open-level-3').forEach((item3) => {
            item3.classList.remove('rotate');
        });
    }
});


const openLevel3 = document.querySelectorAll('.open-level-3');

openLevel3.forEach((item3) => {
    item3.addEventListener('click', (event) => {
        event.stopPropagation();

        document.querySelectorAll('.level-3').forEach((otherLevel3) => {
            if (otherLevel3 !== item3.closest('li').querySelector('.level-3')) {
                otherLevel3.classList.remove('open');
            }
        });
        
        item3.classList.toggle('rotate');
        mainNavigationWrapper.classList.add('scrolled')

        const parentLi = item3.closest('li');
        const level3 = parentLi ? parentLi.querySelector('.level-3') : null;

        if (level3) {
            level3.classList.toggle('open');
        }
    });
});

document.addEventListener('click', (event) => {
    const clickedElement = event.target as HTMLElement;
    const isInsideLevel3 = clickedElement.closest('.level-3');
    
    if (!isInsideLevel3) {
        document.querySelectorAll('.level-3').forEach((level3) => {
            level3.classList.remove('open');
        });

        document.querySelectorAll('.open-level-3').forEach((item3) => {
            item3.classList.remove('rotate');
        });
    }
});



const openLevel4 = document.querySelectorAll('.open-level-4');

openLevel4.forEach((item4) => {
    item4.addEventListener('click', (event) => {
        event.stopPropagation();
        item4.classList.toggle('rotate');

        const parentLi = item4.closest('li');
        const level4 = parentLi ? parentLi.querySelector('.level-4') : null;

        if (level4) {
            level4.classList.toggle('open');
        }
    });
});

document.addEventListener('click', (event) => {
    const clickedElement = event.target as HTMLElement;
    const isInsideLevel4 = clickedElement.closest('.level-4');

    if (!isInsideLevel4) {
        document.querySelectorAll('.level-4').forEach((level4) => {
            level4.classList.remove('open');
        });

        document.querySelectorAll('.open-level-4').forEach((item4) => {
            item4.classList.remove('rotate');
        });
    }
});


const openLevel5 = document.querySelectorAll('.open-level-5');

openLevel5.forEach((item5) => {
    item5.addEventListener('click', (event) => {
        event.stopPropagation();
        item5.classList.toggle('rotate');

        const parentLi = item5.closest('li');
        const level5 = parentLi ? parentLi.querySelector('.level-5') : null;

        if (level5) {
            level5.classList.toggle('open');
        }
    });
});

document.addEventListener('click', (event) => {
    const clickedElement = event.target as HTMLElement;
    const isInsideLevel5 = clickedElement.closest('.level-5');

    if (!isInsideLevel5) {
        document.querySelectorAll('.level-5').forEach((level5) => {
            level5.classList.remove('open');
        });

        document.querySelectorAll('.open-level-5').forEach((item5) => {
            item5.classList.remove('rotate');
        });
    }
});


// Mapbox
